var exports = {
  "x6": "FeedButton.module__button___alVQMj",
  "td": "FeedButton.module__iconText___alVQMj",
  "yF": "FeedButton.module__iconTextSelected___alVQMj",
  "wm": "FeedButton.module__logo___alVQMj",
  "H_": "FeedButton.module__logoHighlighted___alVQMj" + " " + "FeedButton.module__logo___alVQMj",
};

module.exports = exports;
